export const LANGUAGES = ['en'] as const
